import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    loadingWindow: {
      display: 'flex',
      alignItems: 'center',
      minHeight: 200,
    },
    buttonsWrapper: {
      padding: 10,
    },
  }),
);

export default useStyles;
